<template>
  <div class="layout">
    <NavBar :currentNav="currentNav" @select="handleSelect" />
    <HomeTrain :trainTypeList="trainTypeList" />
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator'
import NavBar from './components/NavBar.vue'
import HomeTrain from '@src/components/homeTrain'

@Component({
  components: { NavBar, HomeTrain },
})
export default class Home extends Vue {
  currentNav = 'ST'

  handleSelect(val) {
    this.currentNav = val
  }

  get trainTypeList() {
    return [this.currentNav]
  }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
